<template>
  <div  class="absolute top-0 flex flex-col justify-center h-full overflow-y-auto lg:sticky lg:w-1/6"
    style="background-color:#57b; z-index: 60;">

    <div class="h-screen" style="background-color:#57b;">
    <!-- LOGO -->
    <router-link
      id="logo"
      :to="{ name: 'group.select' }"
      class="block p-4 has-text-centered"
      style="height:65px"
    >
      <div class="h-12 logoOFF" :style="'-webkit-mask: url('+logoUrl+') no-repeat 50% 50%; mask: url('+logoUrl+') no-repeat 50% 50%; background-color: white'"></div>
    </router-link>
    <!-- SIDEBAR menu -->
    <sidebarmenu
      :data="menuSuperAdmin"
      v-if="this.user && this.user.root"
      @epc-show-sidebar="_HandleShowSidebar"
    ></sidebarmenu>
    <sidebarmenu
      :data="menuDataAdminArea"
      v-if="this.user && this.user.areas.can_admin"
      @epc-show-sidebar="_HandleShowSidebar"
    ></sidebarmenu>
    <sidebarmenu
      :data="menuDataAdminProject"
      v-if="
        this.user && !this.user.areas.can_admin && this.user.projects.can_admin
      "
      @epc-show-sidebar="_HandleShowSidebar"
    ></sidebarmenu>
    <sidebarmenu
      :data="menuDataOthers"
      v-if="
        this.user && !this.user.areas.can_admin && !this.user.projects.can_admin
      "
      @epc-show-sidebar="_HandleShowSidebar"
    ></sidebarmenu>

  </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebarmenu from "./SidebarMenu";

export default {
  components: {
    Sidebarmenu
  },

  data: () => ({
    appName: window.config.appName,
    menuDataAdminArea: [
      {
        sectionType: "menu",
        sectionTitle: "administrator",
        icon: null,
        items: [
          //{ title: 'home', icon: 'tachometer-alt', url: 'admin.home' },
          { title: "areas", icon: "sitemap", url: "admin.areas" },
          { title: "groups", icon: "folder", url: "admin.groups" },
          { title: "projects", icon: "clipboard-list", url: "admin.projects" },
          { title: "users", icon: "users", url: "admin.users" },
          { title: "collaborators", icon: "handshake", url: "admin.partners" },
          { title: "validations", icon: "project-diagram", url: "admin.validations" },
          { title: "project_templates", icon: "file-alt", url: "admin.project-templates" },
          { title: "measurement_units", icon: "ruler-combined", url: "admin.measurement-units" },
          { title: 'issues', icon: 'exclamation-triangle', url: 'admin.issues' },
          { title: "customfields", icon: "object-ungroup", url: "admin.customfields" },
          { title: "permitting", icon: "file-signature", url: "admin.permittings" },
          { title: "autodesk", icon: "cloud", url: "admin.autodesk" },
          //{ title: "livemap", icon: "map", url: "admin.livemap" }
          // { title: 'account_and_invoicing', icon: 'sliders-h', url: null },
        ]
      },
      {
        sectionType: "spacer"
      },
       {
        sectionType: "menu",
         sectionTitle: "corporate_zone",
        icon: "play-circle",
         items: [
           { title: "incidents", icon: "exclamation-triangle", url: "corporate.issues" },
           { title: "permitting", icon: "file-signature", url: "corporate.permittings" },
         ]
       },
      {
        sectionType: "menu",
        sectionTitle: "work_zone",
        icon: "play-circle",
        items: []
      },     
    ],
    menuDataAdminProject: [
      {
        sectionType: "menu",
        sectionTitle: "administrator",
        icon: null,
        items: [{ title: "projects", icon: "clipboard-list", url: "admin.projects" }]
      },
      {
        sectionType: "spacer"
      },
      {
        sectionType: "menu",
        sectionTitle: "work_zone",
        icon: "play-circle",
        items: []
      }
    ],
    menuDataOthers: [
      {
        sectionType: "menu",
        sectionTitle: "",
        icon: null,
        items: []
      },
      {
        sectionType: ""
      },
      {
        sectionType: "menu",
        sectionTitle: "work_zone",
        icon: "play-circle",
        items: []
      }
    ],
    // Mapeo entre moduleKey y title del menú
    moduleToMenuMap: {
      'activities': 'activities_planning',
      'document_manager': 'document_manager',
      'workflows': 'validations',
      'technical_specifications': 'technical_specification',
      'boq': 'measurements',
      'certifications': 'certifications',
      'documents': 'documents',
      'drawings': 'drawings',
      'issues': 'incidents',
      'organization_chart': 'org_chart',
      'warehouse': 'storehouse',
      'bim_module': 'bim_module',
      'locations': 'locations',
      'permitting': 'permitting',
    },
    workZoneMenuBase: [
      { title: "select_project", icon: "th", url: "group.select" },
      { title: "project_menu", icon: "tv", url: "project.home" },
      { title: "activities_planning", icon: "lightbulb", url: "project.activities"
        // subitems: [
        //   { title: 'submenu_1', url: null },
        // ]
      },
      { title: "document_manager", icon: "folder-plus", url: "project.activities.folders" },
      { title: "validations", icon: "project-diagram", url: "project.validations" },
      { title: "technical_specification", icon: "cogs", url: "project.technical-specifications" },
      { title: "measurements", icon: "list", url: "project.measurements" },
      { title: "certifications", icon: "certificate", url: "project.certifications" },
      { title: "documents", icon: "file", url: "project.documents" },
      { title: "drawings", icon: "file-pdf", url: "project.drawings" },
      { title: "incidents", icon: "exclamation-triangle", url: "project.issues" },
      { title: "org_chart", icon: "code-branch", url: "project.orgchart" },
      { title: "storehouse", icon: "store-alt", url: "project.storehouse" },
      { title: "bim_module", icon: "file-invoice", url: "project.bim" },
      { title: "locations", icon: "map-marker-alt", url: "project.locations" },
      { title: "permitting", icon: "file-signature", url: "permitting.workzone" },
      // { title: 'daily_report', icon: 'clipboard', url: null },
    ],
    selectProjectMenu: [
      { title: "select_project_menu", icon: "th", url: "group.select" }
    ],

    menuSuperAdmin: [
      {
        sectionType: "menu",
        sectionTitle: "superadmin",
        icon: null,
        items: [
          //{ title: 'home', icon: 'tachometer-alt', url: 'admin.home' },
          { title: "companies", icon: "building", url: "panel.companies" },
        ]
      }
    ],

    version: window.config.version,
    logoUrl: window.config.assetUrl ? window.config.assetUrl + '/img/logo.svg' : '/img/logo.svg',
  }),

  computed: mapGetters({
    user: "auth/user",
    project: "app/project",
    authenticated: "auth/check"
  }),

  watch: {
    project() {
      this.changeWorkZoneMenu();
    }
  },

  mounted() {

    this.changeWorkZoneMenu();

    // mostrar opcion "administrador de subcontratas" si user no es administrador de areas ni proyectos, pero si de alguna subcontrata
    if (this.user && this.user.partners.can_admin) {
      this.menuDataOthers[0].sectionTitle = "administrador"
      this.menuDataOthers[0].items.unshift({ title: "collaborators", icon: "handshake", url: "admin.partners" })
      this.menuDataAdminProject[0].sectionTitle = "administrador"
      this.menuDataAdminProject[0].items.push({ title: "collaborators", icon: "handshake", url: "admin.partners" })

    }

    if (this.user.company.alias == 'welink' || this.user.company.alias == 'ignis') {	
      this.menuDataAdminArea[0].items.push({ title: "sharepoint_config", icon: "cogs", url: "admin.sharepoint-config" })
    }
  },

  methods: {
    // Filtra el menú basándose en los módulos habilitados del proyecto
    getFilteredWorkZoneMenu() {
      const modules = this.project?.configs?.modules;

      // Si no hay módulos configurados, mostrar todo (usuarios existentes sin config)
      if (!modules || !Array.isArray(modules) || modules.length === 0) {
        return this._applyInitialViewUrl(this.workZoneMenuBase);
      }

      // Crear un Set con los títulos de menú que están habilitados
      const enabledMenuTitles = new Set();

      modules.forEach(mod => {
        // Si el módulo está habilitado, agregar su título de menú correspondiente
        if (mod.enabled) {
          const menuTitle = this.moduleToMenuMap[mod.key];
          if (menuTitle) {
            enabledMenuTitles.add(menuTitle);
          }
        }
      });

      // Items que requieren un rol específico para ser visibles
      const canAccessWarehouse = this.project?.can_admin || this.project?.can_warehouse_manager;

      // Filtrar el menú base
      const filtered = this.workZoneMenuBase.filter(item => {
        // Siempre mostrar "select_project" y "project_menu"
        if (item.title === 'select_project' || item.title === 'project_menu') {
          return true;
        }
        // Almacén solo visible para admins y responsables de almacén
        if (item.title === 'storehouse' && !canAccessWarehouse) {
          return false;
        }
        // Si no hay config para este item, mostrarlo por defecto
        if (!Object.values(this.moduleToMenuMap).includes(item.title)) {
          return true;
        }
        // Mostrar solo si está habilitado
        return enabledMenuTitles.has(item.title);
      });

      return this._applyInitialViewUrl(filtered);
    },

    // Aplica la URL correcta al item de activities_planning según la vista inicial configurada
    _applyInitialViewUrl(items) {
      // El colaborador siempre ve la lista de actividades, sin importar la config del proyecto
      const isCollaborator = this.project?.can_collaborate;
      const initial = isCollaborator ? 'activities' : (this.project?.configs?.initial_view_activities || 'activities');

      // tenemos 2 tipos de Almacenes: Classic storehouse (0) y Warehouse v2.0 (1)
      const warehouseType = Number(this.project && this.project.warehouse_type ? this.project.warehouse_type : 0);
      const warehouseRoute = warehouseType === 1 ? 'project.warehouse' : 'project.storehouse';

      return items.map(item => {
        if (item.title === 'activities_planning') {
          const routeByInitialView = {
            groups: 'project.activities.groups',
            weekly: 'project.activities.weekly',
            activities: 'project.activities',
          }
          return { ...item, url: routeByInitialView[initial] || 'project.activities' }
        }
        if (item.title === 'storehouse') {
          return { ...item, url: warehouseRoute };
        }
        return item;
      });
    },

    changeWorkZoneMenu() {
      if (this.project !== null) {
        let emptyProject =
          Object.keys(this.project).length === 0 &&
          this.project.constructor === Object;

        // Obtener el menú filtrado según los módulos del proyecto
        const filteredMenu = this.getFilteredWorkZoneMenu();

        if (this.user.areas.can_admin) {
          this.menuDataAdminArea[3].items = emptyProject
            ? this.selectProjectMenu
            : filteredMenu;
        } else if (!this.user.areas.can_admin && this.user.projects.can_admin) {
          this.menuDataAdminProject[2].items = emptyProject
            ? this.selectProjectMenu
            : filteredMenu;
        } else if (
          !this.user.areas.can_admin &&
          !this.user.projects.can_admin
        ) {
          this.menuDataOthers[2].items = emptyProject
            ? this.selectProjectMenu
            : filteredMenu;
        }
      } else {
        //Mostramos la opción de "Seleccionar proyecto..."
        if (this.user && this.user.areas.can_admin) {
          this.menuDataAdminArea[3].items = this.selectProjectMenu;
        } else if (this.user && !this.user.areas.can_admin && this.user.projects.can_admin) {
          this.menuDataAdminProject[2].items = this.selectProjectMenu;
        } else if (
          this.user &&
          !this.user.areas.can_admin &&
          !this.user.projects.can_admin
        ) {
          this.menuDataOthers[2].items = this.selectProjectMenu;
        }
      }
    },

    _HandleShowSidebar(e) {
      this.$emit('epc-show-sidebar', e)
    }
  }
};
</script>
